import '../../Table/Table.scss';

const CustomerTableHeader = () => {
  return (
    <thead className="table_head">
      <tr>
        <th>Name</th>
        <th className="email">Email</th>
        <th>Phone Number</th>
        <th className="user-id">UserID</th>
        <th>Reg Date</th>
      </tr>
    </thead>
  );
};

const AdminTableHeader = () => {
  return (
    <thead>
      <tr>
        <th></th>
      </tr>
    </thead>
  );
};

export { CustomerTableHeader, AdminTableHeader };
